import React from 'react';

interface ChatHeaderProps {
  title: string;
  photoUrl?: string | null;
  isGuest?: boolean;
  isOnline?: boolean;
  onBack?: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({
  title,
  photoUrl,
  isGuest,
  isOnline,
  onBack
}) => {
  const initials = title.slice(0, 2).toUpperCase();

  return (
    <div className="flex items-center p-3 md:p-4 border-b border-gray-200 bg-white shadow-sm z-20 sticky top-0 flex-shrink-0">
      {onBack && (
        <button
          onClick={onBack}
          className="mr-2 md:hidden p-2 -ml-1 text-gray-600 hover:bg-gray-100 active:bg-gray-200 rounded-full touch-manipulation"
          aria-label="Back to conversations"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2.5}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
      )}

      <div className="relative flex-shrink-0">
        {photoUrl ? (
          <img
            src={photoUrl}
            alt={title}
            className="h-10 w-10 md:h-11 md:w-11 rounded-full object-cover"
          />
        ) : (
          <div
            className={`h-10 w-10 md:h-11 md:w-11 rounded-full flex items-center justify-center text-white text-sm md:text-base font-bold ${isGuest ? 'bg-orange-500' : 'bg-gradient-to-tr from-blue-400 to-blue-600'}`}
          >
            {initials}
          </div>
        )}
        {isGuest && (
          <span className="absolute -bottom-1 -right-1 bg-orange-600 text-white text-[9px] px-1 py-0.5 rounded-full border-2 border-white">
            Guest
          </span>
        )}
      </div>

      <div className="ml-3 flex-1 min-w-0">
        <h3 className="font-semibold text-sm md:text-base text-gray-900 flex items-center gap-2 truncate">
          <span className="truncate">{title}</span>
          {isGuest && (
            <span className="text-xs font-normal text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded flex-shrink-0">
              Inquiry
            </span>
          )}
        </h3>
        <p className="text-xs text-gray-500 flex items-center">
          {isGuest ? 'Guest User' : ''}
        </p>
      </div>

      <div className="ml-auto flex gap-2">
        {/* Action buttons like Info, Call, etc. */}
      </div>
    </div>
  );
};
